import { providersAPI } from "@/views/Providers/services/api";
import { contractorsAPI } from "@/views/Contractors/services/api";

export const getHandbookProviders = async () => {
  try {
    const res = await providersAPI.getList();
    return res?.data;
  } catch (e) {}
};
export const addHandbookProvider = async (body = {}) => {
  const formData = new FormData();
  Object.entries(body).forEach(([key, value]) => {
    formData.append(key, value);
  });
  try {
    const res = await providersAPI.addProvider(formData);
    return res?.data;
  } catch (e) {
  }
};

export const updateHandbookProvider = async (provider_id, body = {}) => {
  try {
    const res = await providersAPI.updateProvider(provider_id, body);
    return res?.data;
  } catch (e) {}
};
export const deleteHandbookProvider = async (provider_id) => {
  try {
    const res = await providersAPI.deleteProvider(provider_id);
    return res?.data;
  } catch (e) {}
};
export const getCity = async () => {
  try {
    const res = await contractorsAPI.getCity();
    return res?.data;
  } catch (e) {}
};
export const getProviderType = async () => {
  try {
    const res = await providersAPI.getProviderType();
    return res?.data;
  } catch (e) {}
};
export const getProviderCountry = async () => {
  try {
    const res = await providersAPI.getProviderCountry();
    return res?.data;
  } catch (e) {}
};
export const getContragentType = async () => {
  try {
    const res = await contractorsAPI.getContragentType();
    return res?.data;
  } catch (e) {}
};
export const mapSBSVidyDeyatelnosti = async (body = {}) => {
  try {
    const res = await contractorsAPI.getSBSVidyDeyatelnosti(body);
    return res?.data;
  } catch (e) {}
};
export const getSBSsnr = async () => {
  try {
    const res = await contractorsAPI.getSBSsnr();
    return res?.data;
  } catch (e) {}
};
export const sendTo1C = async (provider_id) => {
  try {
    const response = await providersAPI.send1C(provider_id);
    return response;
  } catch (error) {}
};
export const providersColumns = [
  {
    name: "provider_id",
    field: "provider_id",
    label: "ID",
    align: "center",
  },
  {
    name: "provider_name",
    field: "provider_name",
    label: "Юридическое наименование",
    align: "left",
  },
  {
    name: "snr",
    field: "snr",
    label: "Режим налогообложения (СНР) / ОКЭД",
    align: "center",
  },
  {
    name: "is_not_create_auto_payment",
    field: "is_not_create_auto_payment",
    label: "Доп. информация",
    align: "center",
  },
  { name: "city_name", field: "city_name", label: "Город", align: "center" },
  { name: "phone", field: "phone", label: "Контактная информация", align: "left" },
  { 
    name: "bank_name", 
    field: "bank_name",
    label: "Банковские реквизиты",
    align: "left" 
  },
  { name: "comment", field: "comment", label: "Комментарии", align: "center" },
  {
    name: "is_send_to_1c_text",
    field: "is_send_to_1c_text",
    label: "1C",
    align: "center",
  },
  { name: "edit", field: "edit", label: "Действия", align: "center" },
];
